import { Team } from '@components/slider-cartes-image-nom/models';
import { ElasticSearchResponse, TeamDocument } from '@shared/services/elastic-search/models';

export const teamsSerializer = (response: ElasticSearchResponse<TeamDocument>): Team[] =>
  response.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      name: source.name?.[0] ?? '',
      position: source.position?.[0] ?? '',
      image: source.image?.[0] ?? undefined!,
    };
  });
